/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthorizationLeadWaitlistStatusSetByUserUserType
 */
export interface PalAuthorizationLeadWaitlistStatusSetByUserUserType {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUserUserType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUserUserType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUserUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUserUserType
     */
    description?: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadWaitlistStatusSetByUserUserType interface.
 */
export function instanceOfPalAuthorizationLeadWaitlistStatusSetByUserUserType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadWaitlistStatusSetByUserUserTypeFromJSON(json: any): PalAuthorizationLeadWaitlistStatusSetByUserUserType {
    return PalAuthorizationLeadWaitlistStatusSetByUserUserTypeFromJSONTyped(json, false);
}

export function PalAuthorizationLeadWaitlistStatusSetByUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadWaitlistStatusSetByUserUserType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function PalAuthorizationLeadWaitlistStatusSetByUserUserTypeToJSON(value?: PalAuthorizationLeadWaitlistStatusSetByUserUserType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'type': value.type,
        'description': value.description,
    };
}

